export default {
    setRanks(state, ranks) {
        state.ranks = ranks
    }
}
